import { Paper, ThemeIcon, Text, Progress, Group } from "@mantine/core";
import { motion } from "framer-motion";

interface SkillProps {
  name: string;
  // progress: number;
  icon: JSX.Element;
}

function Skill(props: SkillProps) {
  return (
    <>
      <motion.div
        whileHover={{
          scale: 1.05,
        }}
        transition={{ type: "spring", stiffness: 700, damping: 5 }}
      >
        <Paper radius="xl" p="lg" withBorder>
          <Group>
            <ThemeIcon size={50} radius={25} variant="outline">
              {props.icon}
            </ThemeIcon>

            <Text>{props.name}</Text>
          </Group>

          {/* <Progress value={props.progress} /> */}
        </Paper>
      </motion.div>
    </>
  );
}

export default Skill;
